
import moment from "moment";
export class InvoiceTransformer {
    static transform(invoice) {
        return {
            id: invoice.id,
            number: invoice.attributes.number,
            date: invoice.attributes.date,
            text: invoice.attributes.text,
            tax: invoice.attributes.tax,
            value: invoice.attributes.value,
            meta_data: invoice.attributes.meta_data,
            status: invoice.attributes.status,
            approved_at: invoice.attributes.approved_at,
        };
    }
}



// WEBPACK FOOTER //
// ./src/helpers/invoices/invoice.transformer.js